import React from "react"
import { Grid } from "@mui/material"
import {
	ReportMinMaxAlertField,
	ReportNotAvailableAlertField,
	ReportPriceChangeAlertField,
	ReportPriceComparisonAlertField,
	ReportRatingAlertField
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import ReportFormSectionDivider from "Pages/ReportsAlerts/Reports/@components/FormDrawer/SectionDivider"
import { AppAntSwitch } from "@components"
import { useSignal } from "@preact/signals-react"
import { reportFormData, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"

export default function ReportFormDrawerAlertsSection() {
	const {
		conditionsRating,
		conditionsPriceMinmax,
		conditionsPriceComparison,
		conditionsNotAvailability,
		conditionsPriceChange
	} = reportFormData.peek()
	const showSection = useSignal(!!(conditionsRating?.length || conditionsPriceMinmax?.length || conditionsPriceComparison?.length || conditionsNotAvailability?.length || conditionsPriceChange?.length))

	if (selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING) return null

	return <Grid container spacing={2}>
		<Grid item xs={2} data-tour-id="tour-alerts">
			<ReportFormSectionDivider title="Alerts Configuration" icon="cowbell"/>
		</Grid>
		<Grid item xs={1}>
			<AppAntSwitch
				checked={showSection.value}
				onChange={e => showSection.value = e.target.checked}
				trueText="Show"
			/>
		</Grid>
		<Grid item xs={9}/>
		{showSection.value && <>
			<Grid item xs={3}>
				<ReportRatingAlertField/>
			</Grid>
			<Grid item xs={3}>
				<ReportMinMaxAlertField/>
			</Grid>
			<Grid item xs={3}>
				<ReportPriceComparisonAlertField/>
			</Grid>
			<Grid item xs={3}>
				<ReportNotAvailableAlertField/>
			</Grid>
			<Grid item xs={3}>
				<ReportPriceChangeAlertField/>
			</Grid>
		</>}
	</Grid>
}